import React, { useCallback, memo, useEffect, useContext } from "react";
import PropTypes from "prop-types";

import SelectBoxNavTabs from "components/selectBox/SelectBoxNavTabs";
import SelectBoxItems from "components/selectBox/SelectBoxItems";
import { SelectBoxContext } from "components/selectBox/SelectBoxContext";
import Spinner from "components/utils/Spinner";

const BOX_ITEMS_ZONE_HEIGHT = 500;

const selectedTabs = [{ key: "selected", icon: "", index: 0 }];

function SelectBoxZone({ hasRank, selected, tabs }) {
  const context = useContext(SelectBoxContext);

  useEffect(() => {
    if (!selected) context.setSelectedTab(tabs[0]);
  }, []);

  const handleChangeTab = useCallback(
    (index) => {
      if (!selected) {
        const selected_tab = tabs.find((tab) => tab.index === index);
        context.setSelectedTab(selected_tab);
      }
    },
    [selected, context.setSelectedTab],
  );

  if (!selected && !context.selectedTab) return null;

  const items = selected
    ? context.selectedFilteredItems
    : context.libraryFilteredItems;

  return (
    <div className="selectbox-zone-container relative flex flex-col shadow-(--shadow)">
      <SelectBoxNavTabs
        changeTab={handleChangeTab}
        selected={selected}
        tabs={selected ? selectedTabs : tabs}
        tab_index={!selected ? context.selectedTab.index : 0}
        // Once content is empty, remove check mark if any
        isChecked={items.length === 0 ? false : undefined}
        canCheck={items.length > 0}
      />
      {context.computeOrdering ? (
        <div
          className="selectbox-zone-spinner"
          style={{ height: `${BOX_ITEMS_ZONE_HEIGHT}px` }}
        >
          <Spinner />
        </div>
      ) : (
        <SelectBoxItems
          hasRank={hasRank}
          items={items}
          source_id={selected ? "droppableSelected" : "droppableLibrary"}
          height={BOX_ITEMS_ZONE_HEIGHT}
        />
      )}
    </div>
  );
}

SelectBoxZone.propTypes = {
  hasRank: PropTypes.bool,
  selected: PropTypes.bool,
  tabs: PropTypes.array,
};

export default memo(SelectBoxZone);
